import type { InitialDataResponse } from './models/initialDataResponse'

export class CmsDataService<InitialDataR extends InitialDataResponse> {
    private data: InitialDataR

    public getOccOverride(siteId: string) {
        if (!siteId) return undefined

        if (this.data?.occConfigurationOverride !== undefined && !!this.data.occConfigurationOverride.length) {
            return this.data.occConfigurationOverride.find(o => o.vistaCinema?.key === siteId)
        }

        return undefined
    }

    public set(data: InitialDataR) {
        this.data = data
    }

    public get(): InitialDataR {
        return this.data
    }
}
